import { App } from 'hydra-data-types';
import i18n from 'i18n-js';
import memoize from 'lodash.memoize';
import { Environment } from './Environment';

// Adapted from https://github.com/zoontek/react-native-localize/blob/master/example/src/SyncExample.js

/* eslint-disable @typescript-eslint/no-require-imports */
const translationGetters: { [locale: string]: () => Record<string, unknown> } = {
  'en-nerva': () => require('../content/en-nerva.json'),
  'en-meno': () => require('../content/en-meno.json'),
  'en-quit': () => require('../content/en-quit.json'),
  'en-pain': () => require('../content/en-pain.json'),
};
/* eslint-enable @typescript-eslint/no-require-imports */

export const translate = memoize(
  i18n.t,
  function cacheKey(scope: i18n.Scope, options?: i18n.TranslateOptions) {
    return options !== undefined ? scope + JSON.stringify(options) : scope;
  }
);

function initialize(app: App = Environment.APP): void {
  translate.cache.clear?.();
  i18n.fallbacks = true;
  i18n.defaultLocale = 'en-nerva'; // Fallback to this locale if no translation exists
  i18n.locale = `en-${app}`; // Set from the device locale to support multiple languages

  i18n.translations = {
    [i18n.defaultLocale]: translationGetters[i18n.defaultLocale](),
    [i18n.locale]: translationGetters[i18n.locale](),
  };
}

export const Localization = {
  initialize,
};
